/** The 19 tabs of a social case file (AS-DS-US-001), in display order; only the visible ones render,
 *  so only they carry a label key. */
export const SOCIAL_CASE_FILE_TABS = [
    { key: "resume", labelKey: "reception.socialCaseFile.tabs.resume", visible: true, editable: false },
    { key: "detail", labelKey: "reception.socialCaseFile.tabs.detail", visible: true, editable: true },
    { key: "household", labelKey: "reception.socialCaseFile.tabs.household", visible: true, editable: true },
    { key: "socioEconomic", labelKey: "reception.socialCaseFile.tabs.socioEconomic", visible: true, editable: true },
    { key: "budget", labelKey: "reception.socialCaseFile.tabs.budget", visible: true, editable: true },
    { key: "interactions", visible: false, editable: false },
    { key: "evaluations", labelKey: "reception.socialCaseFile.tabs.evaluations", visible: true, editable: false },
    { key: "project", labelKey: "reception.socialCaseFile.tabs.project", visible: true, editable: true },
    { key: "intervention", visible: false, editable: false },
    { key: "orientation", visible: false, editable: false },
    { key: "form", visible: false, editable: false },
    { key: "adminDigital", visible: false, editable: false },
    { key: "insertion", visible: false, editable: false },
    { key: "housing", visible: false, editable: false },
    { key: "health", visible: false, editable: false },
    { key: "vulnerability", visible: false, editable: false },
    { key: "domesticViolence", visible: false, editable: false },
    { key: "childProtection", visible: false, editable: false },
    { key: "documents", visible: false, editable: false },
];
export const DEFAULT_SOCIAL_CASE_FILE_TAB = "resume";
export const VISIBLE_SOCIAL_CASE_FILE_TABS = SOCIAL_CASE_FILE_TABS.filter((tab) => tab.visible);
export function isVisibleSocialCaseFileTabKey(value) {
    return VISIBLE_SOCIAL_CASE_FILE_TABS.some((tab) => tab.key === value);
}
/** The tab a `:tab` route param shows: an unknown or hidden one falls back to the default. */
export function toVisibleSocialCaseFileTab(param) {
    return isVisibleSocialCaseFileTabKey(param) ? param : DEFAULT_SOCIAL_CASE_FILE_TAB;
}
/** Why an editable tab is read-only, `null` when it may write. An archived file is never edited,
 *  whatever its gate says. */
export function socialCaseFileTabLock(tab, file) {
    if (!tab.editable)
        return null;
    if (file.status === "archived")
        return "archived";
    return file.directEditEnabled ? null : "directEditDisabled";
}
